<template>
  <div class="TcCalendarDay">
    <h5 class="text-center">{{ week_day_name }}</h5>
    <div class="text-center text-4xl font-bold">{{ date.date.getDate() }}</div>
    <ul class="flex flex-col items-center gap-3 mt-5 pb-10">
      <li v-for="slot in date.slots" :key="slot.time" class="mb-0 rounded-lg shadow-md">
        <div v-if="slot.active==true" @click="newAppointmentClick(slot)"
          class="bg-green-400 hover:bg-green-500 text-white py-2 text-lg px-16 rounded-lg cursor-pointer"
        ><span>{{slot.time}}</span></div>
        <div v-else
          class="bg-gray-400 py-2 text-lg px-16 rounded-lg opacity-20"
        >{{slot.time}}</div>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
export default {
  name: 'TcCalendarDay',
  props: ['date','room'],
  data () {
    return {
      week_day_name: '',
    }
  },
  created() {
    //console.log('DAY CREATED')
    this.week_day_name = this.$props.date.date.toLocaleDateString('es-ES',{ weekday: 'long' })
  },
  methods: {
    newAppointmentClick: function(slot) {
      //console.log('newAppointmentClick', this.$props.date.date, this.$props.room.id, slot);
      this.$parent.selected_slot = slot;
      this.$parent.creatingAppointment = true;
    }
  }
}
</script>
